export const signupStep3Schema = {
  fields: [
    {
      name: 'address1',
      label: 'Address (Line 1)',
      type: 'text',
      placeholder: 'Enter address line 1',
      required: true,
    },
    {
      name: 'address2',
      label: 'Address (Line 2)',
      type: 'text',
      placeholder: 'Enter address line 2',
      required: false,
    },
    {
      name: 'cityStateGroup',
      type: 'group',
      children: [
        {
          name: 'city',
          label: 'City',
          type: 'text',
          placeholder: 'Enter city',
          required: true,
        },
        {
          name: 'state',
          label: 'State',
          type: 'text',
          placeholder: 'Enter state',
          required: true,
        },
      ],
    },
    {
      name: 'countryPostalGroup',
      type: 'group',
      children: [
        {
          name: 'country',
          label: 'Country',
          type: 'text',
          placeholder: 'Enter country',
          required: true,
        },
        {
          name: 'postalCode',
          label: 'Postal Code',
          type: 'text',
          placeholder: 'Enter postal code',
          required: true,
        },
      ],
    },
     {
      name: 'captcha',
      label: 'Enter CAPTCHA',
      type: 'captcha',           // use the custom captcha renderer
      src: '/api/captcha',       // your captcha image endpoint
      alt: 'CAPTCHA image',
      required: true,
    },
    {
      name: 'acceptTerms',
      type: 'terms',
      label: 'Please accept all the payment details to proceed further.',
      href: '#',
      linkText: '',
      required: true,
    }
  ],
  buttons: [
    {
      label: 'Back',
      action: 'back',
      type: 'button',
      className: 'btn-back',
    },
    {
      label: 'Finish',
      action: 'finish',
      type: 'button',
      className: 'btn-next',
    },
  ],
};
